import { authPost } from "../../common/redux/ApiClient";

const baseUrl = "http://35.240.204.237/ok99memberApi/api";

export function fetchSportPageUI(params) {
  return authPost(`${baseUrl}/MemberPc2/PcSportPageUI`, params);
}

export function fetchSportGameList(params) {
  return authPost(`${baseUrl}/MemberPc2/PcSportGameList`, params);
}

export function companyPlayGame(params) {
  return authPost(`${baseUrl}/Member3/CompanyPlayGame`, params);
}
